<template>
  <!-- 店铺管理-评价管理 -->
  <div class="shop-check">
    <div class="ButtonArea">
      <!-- 评价管理 --> 
      <div class="Toggle">
        <p
          v-for="(item, index) in ToggleArr"
          :key="index"
          :class="Toggle == item.id ? 'select-p' : ''"
          @click="Toggle = item.id"
        >
          {{ item.name }}
        </p>
        <div class="screen" v-if="Toggle == '3'">
          本店服务筛选：
          <div class="size-search">
            <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <!-- 金额统计 -->
    <div class="Statistics">
      <div class="logo"></div>
      {{
        Toggle == "1"
          ? "平均评分："
          : Toggle == "2"
          ? "外包评分："
          : "本店评分："
      }}
      <p class="star" v-for="(item, index) in mark" :key="index + 1"></p>
      <p class="null" v-for="(item, index) in 5 - mark" :key="index + 10"></p>
      {{ mark }} 星
    </div>

    <!-- 表格区 -->
    <div class="tabulation">
      <Review :listArr="listArr" :distinguish="1"></Review>
    </div>
    <!-- 分页 -->
    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="pagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>
  </div>
</template>

<script>
import paging from "../../../../../components/paging.vue"; // 分页
import Review from "./components/Review.vue"; // 评论
export default {
  data() {
    return {
      ToggleArr: [
        {
          name: "全部评论（xx）",
          id: "1",
        },
        {
          name: "外包评论",
          id: "2",
        },
        {
          name: "本店服务评论",
          id: "3",
        },
      ], // 账单明细 账单分类
      Toggle: "1", // 账单分类
      value: "", //
      options: [], //状态选项
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 8, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页
      tableData: [{}, {}], // 营收表数据
      mark: 4, //评分
      listArr: [
        {
          status: 0,
          mark: 4,
          EvaluationTag: [
            {
              name: "准时守信",
              id: "1",
            },
            {
              name: "值得推荐",
              id: "2",
            },
          ],
        },
        {
          status: 1,
          mark: 3,
          EvaluationTag: [
            {
              name: "准时守信",
              id: "1",
            },
            {
              name: "值得推荐",
              id: "2",
            },
          ],
        },
        {
          status: 0,
          mark: 4,
          EvaluationTag: [
            {
              name: "准时守信",
              id: "1",
            },
            {
              name: "值得推荐",
              id: "2",
            },
          ],
        },
      ], // 评论数据
    };
  },
  watch: {},
  components: {
    // 分页
    paging,
    // 评论
    Review,
  },
  created() {},
  methods: {
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      // this.RefreshSysMsgList();
    },
  },
};
</script>

<style scoped lang="less">
// 时间选择框样式
/deep/.el-date-editor {
  box-sizing: border-box !important;
  border: 1px solid #409eff ;
  height: 35px;
  width: 240px !important;
  line-height: 35px !important;
  padding: 0 !important;
}
/deep/.el-icon-date {
  font-size: 24px !important;
  margin-left: 10px !important;
}
.shop-check {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #333333;
  font-weight: 400;
  // 按钮区
  .ButtonArea {
    width: 100%;
    height: 35px;
    display: flex;
    // 服务管理/需求管理
    .Toggle {
      display: flex;
      p {
        min-width: 110px;
        height: 33px;
        line-height: 33px;
        background: #ffffff;
        border: 1px solid transparent;
        box-shadow: 0px -3px 10px 0px rgba(153, 153, 153, 0.5);
        border-radius: 10px 10px 0px 0px;
        text-align: center;
        margin-right: 10px;
        cursor: pointer;
      }
      .select-p {
        height: 33px;
        line-height: 33px;
        border: 1px solid #409eff ;
        box-shadow: 0px -3px 10px 0px rgba(153, 153, 153, 0.5);
        color: #409eff ;
      }
    }
    // 筛选
    .screen {
      margin-left: 60px;
      height: 35px;
      line-height: 35px;
      display: flex;
      // 筛选区放input框的div
      .size-search {
        width: 150px;
        height: 35px;
        font-size: 14px;
        /deep/.el-input__inner {
          height: 35px !important;
          border: 1px solid #409eff ;
        }
      }
    }
  }

  // 金额统计
  .Statistics {
    width: 100%;
    height: 25px;
    line-height: 25px;
    color: #333333;
    display: flex;
    margin-top: 30px;
    font-size: 12px;
    .logo {
      width: 25px;
      height: 25px;
      background-image: url("../../../../../assets/imgs/logo.svg");
      background-size: 100% 100%;
      margin-right: 10px;
    }
    p {
      margin: auto 0;
      margin-right: 5px;
    }
    .star {
      width: 15px;
      height: 14px;
      background-image: url("../../../../../assets/imgs/shoucang@3x.svg");
      background-size: 100% 100%;
    }
    .null {
      width: 15px;
      height: 14px;
      background-image: url("../../../../../assets/imgs/shoucang-null@3x.svg");
      background-size: 100% 100%;
    }
  }
  // 表格
  .tabulation {
    min-height: 200px;
    margin-top: 20px;
    margin-top: 30px;
  }
  // 分页
  .paging-box {
    width: 100%;
    height: 22px;
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    .paging {
      width: 90%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
